import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcSwitch from '@/views/Automation/CampaignCreatorV2/components/CcSwitch/CcSwitch.ts.vue';
import { SupportedEntities } from '@/views/Automation/CampaignCreatorV2/store/Types';
import { computed, ref } from 'vue';

// campaign & adset
interface Variable {
  field: string; // key
  name?: string;
  value: string | number;
  type?: string;
}

interface Props {
  id: string;
  movingVariables: string[];
  title: string;
  entity: string;
  active: boolean;
  statusDisabled?: boolean;
  variables: Variable[];
  selected?: boolean;
}

interface Emits {
  (event: 'click'): void;
  (
    event: 'changeStatus',
    value: { status: boolean; movingVariables: string[]; entity: SupportedEntities.campaign | SupportedEntities.adset }
  ): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcPreviewCard.ts',
  props: {
    id: null,
    movingVariables: null,
    title: null,
    entity: null,
    active: { type: Boolean },
    statusDisabled: { type: Boolean },
    variables: { default: () => [] },
    selected: { type: Boolean, default: false }
  },
  emits: ["click", "changeStatus"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'click'): void;
  (
    event: 'changeStatus',
    value: { status: boolean; movingVariables: string[]; entity: SupportedEntities.campaign | SupportedEntities.adset }
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { id: string, movingVariables: string[], title: string, entity: string, active: boolean, statusDisabled?: boolean, variables: Variable[], selected: boolean };

const opened = ref(false);





const imageURL = computed(() => {
  const imageVar = props.variables.find((variable) => variable.field === 'image')?.value ?? {};
  return (imageVar as { image_url?: string })?.image_url as string;
});

const uiVariables = computed(() => {
  const availableVariables = props.variables.filter((variable) => variable.field !== 'image');

  return {
    header: availableVariables.slice(0, 4),
    body: availableVariables.slice(4),
  };
});

function updateStatus(value: boolean) {
  emits('changeStatus', {
    status: value,
    movingVariables: props.movingVariables,
    entity: props.entity as SupportedEntities.campaign | SupportedEntities.adset,
  });
}

function onShowMoreClick() {
  opened.value = !opened.value;
}

return { __sfc: true,opened, props, emits, imageURL, uiVariables, updateStatus, onShowMoreClick, CcIcon, CcSwitch }
}

})